<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <button
    mat-raised-button
    color="success"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    (click)="onNoClick()"
    *ngIf="buttonCancel"
  >
    Complete
  </button>
  <mat-tab-group
    mat-align-tabs="center"
    [selectedIndex]="indexTabs.value"
    (selectedIndexChange)="indexTabs.setValue($event)"
  >
    <mat-tab label="Ship to " [disabled]="tab1">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          [formGroup]="formShipto"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="onNoClick()"
            >
              <mat-icon>west</mat-icon>
              <br />Close<br />
            </button>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="OnNext(1)"
            >
              <mat-icon>east</mat-icon>
              <br />Carrier instructions<br />
            </button>
          </div>
          <mat-form-field
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Search Company</mat-label>
            <input
              matInput
              maxlength="100"
              (keyup)="buscaCompany($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10"
            appearance="fill"
          >
            <mat-label></mat-label>

            <mat-select
              (selectionChange)="OnChangeSelectbusqueda($event)"
              #autocompany
            >
              <mat-option [value]="item" *ngFor="let item of options"
                >{{ item.CompanyName }}----{{ item.Address }}
                {{ item.City }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Company name</mat-label>
            <input
              matInput
              [(ngModel)]="data.Company"
              maxlength="100"
              formControlName="Company"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
          >
            <mat-label>Address</mat-label>
            <input
              matInput
              [(ngModel)]="data.Address"
              maxlength="100"
              formControlName="Address"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Suite#</mat-label>
            <input
              matInput
              [(ngModel)]="data.Address1"
              maxlength="100"
              formControlName="Address1"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>City</mat-label>
            <input
              matInput
              [(ngModel)]="data.City"
              maxlength="75"
              formControlName="City"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>State</mat-label>
            <input
              matInput
              [(ngModel)]="data.State"
              maxlength="50"
              formControlName="State"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Zip Code</mat-label>
            <input
              matInput
              [(ngModel)]="data.Zip"
              maxlength="25"
              formControlName="Zip"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Phone</mat-label>
            <input
              matInput
              [(ngModel)]="data.Phone"
              maxlength="20"
              formControlName="Phone"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Company fax</mat-label>
            <input
              matInput
              [(ngModel)]="data.Fax"
              maxlength="20"
              formControlName="Fax"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact name</mat-label>
            <input
              matInput
              [(ngModel)]="data.Cname"
              maxlength="50"
              formControlName="Cname"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact phone</mat-label>
            <input
              matInput
              [(ngModel)]="data.Cphone"
              maxlength="50"
              formControlName="Cphone"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact email</mat-label>
            <input
              matInput
              [(ngModel)]="data.Cemail"
              maxlength="50"
              formControlName="Cemail"
            />
          </mat-form-field>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          [formGroup]="formBillto"
        >
          <h1
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            BILL TO
          </h1>

          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Company name</mat-label>
            <input matInput maxlength="100" formControlName="Company" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
          >
            <mat-label>Address</mat-label>
            <input matInput maxlength="100" formControlName="Address" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Suite#</mat-label>
            <input matInput maxlength="100" formControlName="Address1" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>City</mat-label>
            <input matInput maxlength="75" formControlName="City" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>State</mat-label>
            <input matInput maxlength="50" formControlName="State" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Zip Code</mat-label>
            <input matInput maxlength="25" formControlName="Zip" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Phone</mat-label>
            <input matInput maxlength="20" formControlName="Phone" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Company fax</mat-label>
            <input matInput maxlength="20" formControlName="Fax" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact name</mat-label>
            <input matInput maxlength="50" formControlName="Cname" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact phone</mat-label>
            <input matInput maxlength="50" formControlName="Cphone" />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Contact email</mat-label>
            <input matInput maxlength="50" formControlName="Cemail" />
          </mat-form-field>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Carrier instructions" [disabled]="tab2">
      <div [formGroup]="fmcarrier">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="OnNext(0)"
            >
              <mat-icon>west</mat-icon>
              <br />Ship to<br />
            </button>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="OnDialogPlaceOrderTwo(data)"
            >
              <mat-icon>east</mat-icon>
              <br />Order items<br />
            </button>
          </div>
          <mat-form-field
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Search Carrier</mat-label>
            <input
              matInput
              maxlength="100"
              (keyup)="buscaCarrier($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10"
            appearance="fill"
          >
            <mat-label></mat-label>

            <mat-select
              (selectionChange)="OnChangeCarriersSearch($event)"
              #autocarrier
            >
              <mat-option [value]="item" *ngFor="let item of CarrirsSearch"
                >{{ item.CarrierName }}----{{ item.SCACCode }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Carrier name</mat-label>
            <input
              matInput
              [(ngModel)]="data.CarrierName"
              maxlength="50"
              formControlName="CarrierName"
              required
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Scac code</mat-label>
            <input
              matInput
              [(ngModel)]="data.SCAC"
              maxlength="10"
              formControlName="scac"
              required
            />
          </mat-form-field>

          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Service type</mat-label>
            <input
              matInput
              [(ngModel)]="data.ServiceType"
              maxlength="50"
              formControlName="ServiceType"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Billing</mat-label>
            <input
              matInput
              [(ngModel)]="data.Billing"
              maxlength="50"
              formControlName="Billing"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Account #</mat-label>
            <input
              matInput
              [(ngModel)]="data.Account"
              maxlength="50"
              formControlName="Account"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Size</mat-label>
            <select
              matNativeControl
              [(ngModel)]="data.SelectCapacity"
              formControlName="SelectCapacity"
            >
              <option value="1">20' Container</option>
              <option value="2">40' Container</option>
              <option value="3">45' HC Container</option>
              <option value="4">48' Trailer</option>
              <option value="5">53' Trailer</option>
              <option value="6">Bobtail</option>
            </select>
          </mat-form-field>
          <mat-checkbox
            class="example-margin col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            [(ngModel)]="data.COD"
            formControlName="cod"
            >COD</mat-checkbox
          >
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Load number</mat-label>
            <input
              matInput
              [(ngModel)]="data.loadnumber"
              maxlength="50"
              formControlName="loadnumber"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>BOL#</mat-label>
            <input
              matInput
              [(ngModel)]="data.BOL"
              maxlength="50"
              formControlName="bol"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Tracking #</mat-label>
            <input
              matInput
              [(ngModel)]="data.Tracking"
              maxlength="50"
              formControlName="Tracking"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Trailer #</mat-label>
            <input
              matInput
              [(ngModel)]="data.Trailer"
              maxlength="50"
              formControlName="Trailer"
            />
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Seal#</mat-label>
            <input
              matInput
              [(ngModel)]="data.Sealnumber"
              maxlength="50"
              formControlName="Sealnumber"
            />
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Pick Up Date.</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              formControlName="PickupDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Door #</mat-label>
            <input
              matInput
              [(ngModel)]="data.Door"
              maxlength="50"
              formControlName="Door"
            />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-label>Warehouse special instructions / Notes</mat-label>
            <textarea
              matInput
              [(ngModel)]="data.warehouseInstructions"
              maxlength="250"
              class="form-control"
              formControlName="warehouseInstructions"
            ></textarea>
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-label>Carrier special instructions / Notes</mat-label>
            <textarea
              matInput
              [(ngModel)]="data.carrierInstructions"
              maxlength="250"
              class="form-control"
              formControlName="carrierInstructions"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <mat-spinner></mat-spinner>
    </mat-tab>
    <mat-tab label="Order items" [disabled]="tab3">
      <div [formGroup]="fmorderitems">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="OnNext(3)"
            >
              <mat-icon>west</mat-icon>
              <br />Carrier instructions<br />
            </button>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-button
              color="primary"
              (click)="OnNext(4)"
            >
              <mat-icon>east</mat-icon>
              <br />Order changes<br />
            </button>
          </div>
          <div *ngIf="!viewEditar" class="row">
            <input
              matInput
              style="border: 1px solid; margin-top: 1.2vh"
              (keyup)="onKeyPlaceProducts($event.target.value)"
              placeholder="search Item#"
              class="form-control col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            />

            <mat-form-field
              class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10"
            >
              <mat-label>select products</mat-label>
              <mat-select
                formControlName="PlaceProducts"
                (selectionChange)="oneProducts($event)"
                #ProdustSelect
              >
                <div *ngFor="let opt of PlaceProducts2">
                  <mat-option [value]="opt">
                    Item: {{ opt.ItemNumber }} Descripcion:
                    {{ opt.ItemDescription }} Location:
                    {{ opt.Location }} location Quantity:
                    {{ opt.locationQuantity }} Lot Number:
                    {{ opt.LotNumber }} available: {{ opt.available }}
                    {{ opt.locationID }}
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            *ngIf="!viewEditar"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            style="padding-bottom: 39px"
          >
            <p
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row justify-content-center"
            >
              <span
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                >Total Weight: {{ TotalWeigth }}</span
              >

              <span
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                >Location: {{ label1 }}</span
              >
              <span
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                >Available: {{ label2 }}</span
              >
              <span
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                >Total Pallets: {{ totalp }}</span
              >
            </p>
          </div>

          <mat-form-field
            *ngIf="!viewEditar"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Quantity</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="data.Quantity"
              formControlName="Quantity"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="!viewEditar"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>{{ LabelProNumber }}</mat-label>
            <input matInput [(ngModel)]="data.Misc" formControlName="Misc" />
          </mat-form-field>
          <mat-form-field
            *ngIf="!viewEditar"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>Pallet</mat-label>
            <input
              type="number"
              matInput
              [(ngModel)]="data.Pallet"
              [value]="1"
              [readonly]="true"
              formControlName="Pallet"
            />
          </mat-form-field>
          <div
            *ngIf="!viewEditar"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <button
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              mat-raised-button
              color="primary"
              (click)="OnNewOrderItems()"
            >
              add an item
            </button>
            <button
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              mat-raised-button
              color="warning"
              (click)="OnNewOrderItemsMasivo()"
            >
              Add Selected
            </button>
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Select pallets</mat-label>
              <mat-select [formControl]="toppings" multiple>
                <mat-option
                  *ngFor="let topping of ResponseListPallets; let i = index"
                  [value]="topping"
                  >{{ i + 1 }}-{{ topping.quantity }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div
            *ngIf="false"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <mat-form-field
              appearance="fill"
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
            >
              <mat-label>PRO</mat-label>
              <input matInput type="text" formControlName="pro" #prota />
            </mat-form-field>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-raised-button
              color="danger"
              style="height: 4vh"
              (click)="OnClearEditarPro()"
            >
              Cancel
            </button>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-raised-button
              color="primary"
              (click)="OnSaveEditarPro()"
              style="height: 4vh"
            >
              Save
            </button>
          </div>

          <div
            *ngIf="viewEditarMasiveP"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>Select Item Number</mat-label>
              <mat-select formControlName="PalletsMasive" multiple>
                <mat-option
                  *ngFor="let itemsP of ArraySelectUpdateMasivePallets"
                  [value]="itemsP"
                  style="height: 5em; line-height: 1em"
                >
                  <p>
                    <span> Item Number:{{ itemsP.ItemNumber }} </span>
                    <br />
                    <span>Location: {{ itemsP.Location }}</span>
                    <br />
                    <span>PRO#:{{ itemsP.miscnumber }}</span>
                    <br *ngIf="poNumberBillOfLading" />
                    <span *ngIf="poNumberBillOfLading"
                      >PO#:{{ itemsP.poNumber }}</span
                    >
                  </p>
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>PRO</mat-label>
              <input matInput type="text" formControlName="pro" #prota />
            </mat-form-field>
            <mat-form-field
              *ngIf="poNumberBillOfLading"
              appearance="fill"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
            >
              <mat-label>PO#</mat-label>
              <input matInput type="text" formControlName="poNumber" #prota />
            </mat-form-field>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-raised-button
              color="danger"
              style="height: 4vh"
              (click)="OnClearEditarPro()"
            >
              Cancel
            </button>
            <button
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              mat-raised-button
              color="primary"
              (click)="OnSaveUpdateByPallets()"
              style="height: 4vh"
            >
              Save
            </button>
          </div>

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            >
              <mat-label>Search</mat-label>
              <input
                matInput
                (keyup)="applyFilter($event)"
                placeholder=""
                #input
              />
            </mat-form-field>

            <div
              class="example-container mat-elevation-z8 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              *ngIf="searchTable"
            >
              <div
                class="example-loading-shade"
                *ngIf="isLoadingResults || isRateLimitReached"
              >
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div
                  class="example-rate-limit-reached"
                  *ngIf="isRateLimitReached"
                ></div>
              </div>

              <div class="example-table-container">
                <table
                  mat-table
                  [dataSource]="dataSourceSearchOrder"
                  class="example-table"
                  matSort
                  matSortDirection="desc"
                  #TableViewProcessordersSort="matSort"
                >
                  <!-- Created Column -->
                  <ng-container matColumnDef="ID">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear
                    >
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menuOrderItems"
                        aria-label="menu Order Items"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuOrderItems="matMenu">
                        <button
                          mat-menu-item
                          color="danger"
                          (click)="Onedeletemodal(row)"
                        >
                          Delete
                        </button>
                        <button
                          mat-menu-item
                          *ngIf="false"
                          color="primary"
                          (click)="OnEditarProNumbermodal(row)"
                        >
                          Edit
                        </button>
                        <button
                          mat-menu-item
                          color="primary"
                          (click)="OnGroupByItems(row.ItemNumber)"
                        >
                          Edit list pro
                        </button>
                        <button
                          mat-menu-item
                          color="primary"
                          (click)="openDialog(row.miscnumber)"
                        >
                          Bill of lading
                        </button>
                      </mat-menu>
                    </td>
                  </ng-container>
                  <!-- Number Column -->
                  <ng-container matColumnDef="ItemNumber">
                    <th mat-header-cell *matHeaderCellDef>
                      <div class="theadTable">Item number</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.ItemNumber }}</div>
                    </td>
                  </ng-container>

                  <!-- Title Column -->
                  <ng-container matColumnDef="Description">
                    <th mat-header-cell *matHeaderCellDef>Description</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Description }}
                    </td>
                  </ng-container>

                  <!-- State Column -->
                  <ng-container matColumnDef="miscnumber">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ LabelProNumber }}
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.miscnumber }}</td>
                  </ng-container>

                  <!-- Created Column -->
                  <ng-container matColumnDef="palletcount">
                    <th mat-header-cell *matHeaderCellDef>
                      <div class="theadTable">Pallet count</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.palletcount }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="Location">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear
                    >
                      Location
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Location }}</td>
                  </ng-container>
                  <!-- Created Column -->
                  <ng-container matColumnDef="Quantity">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear
                    >
                      Quantity
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.Quantity }}</td>
                  </ng-container>
                  <ng-container matColumnDef="poNumber">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear
                    >
                      PO#
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.poNumber }}</td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsOrderItems"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsOrderItems"
                  ></tr>
                </table>
              </div>
            </div>
            <mat-paginator
              [length]="resultsLength"
              [pageSize]="50"
              #TableViewProcessordersPaginator="matPaginator"
              [pageSizeOptions]="[50, 100, 250, 1000]"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Order charges" [disabled]="tab4">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <button
          class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          mat-button
          color="primary"
          (click)="OnNext(2)"
        >
          <mat-icon>west</mat-icon>
          <br />Order items<br />
        </button>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <section class="example-section">
          <mat-checkbox
            class="example-margin"
            [(ngModel)]="checkedAllCharges"
            (change)="OnAllChargesUpdate($event)"
            >All Charges</mat-checkbox
          >
        </section>
      </div>
      <div
        [formGroup]="FormInvoiceHeader"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>From name</mat-label>
            <input matInput formControlName="fromname" />
          </mat-form-field>
        </div>

        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>From street</mat-label>
            <input matInput formControlName="fromstreet" />
          </mat-form-field>
        </div>

        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>To name</mat-label>
            <input matInput formControlName="toname" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>To street</mat-label>
            <input matInput formControlName="tostreet" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Bill name</mat-label>
            <input matInput formControlName="billname" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Bill street</mat-label>
            <input matInput formControlName="billstreet" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Invoice#</mat-label>
            <input matInput formControlName="invoicenumber" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Payment Terms.</mat-label>
            <input matInput formControlName="payterm" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Customer</mat-label>
            <input matInput formControlName="customerid" />
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Reference#</mat-label>
            <input matInput formControlName="referencesnumber" />
          </mat-form-field>
        </div>
        <div
          class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
        >
          <mat-form-field color="accent" appearance="fill" class="InputSty">
            <mat-label>Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker1DateInvoice"
              formControlName="dateinvoice"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1DateInvoice"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1DateInvoice></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field class="example-full-width">
            <mat-label>Total amount</mat-label>
            <input matInput formControlName="totalamount" />
          </mat-form-field>
        </div>
        <div
          class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty"
        >
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
          >
            <mat-label>Note</mat-label>
            <textarea matInput formControlName="noteinvoice"></textarea>
          </mat-form-field>
        </div>

        <button
          mat-raised-button
          color="primary"
          class="col-md-2 InputSty"
          (click)="OnInvoiceHeaderInsert()"
        >
          {{ labelInvoiceHeaderButton }}
        </button>
      </div>
      <div [formGroup]="fmorderchargers">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <p
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row justify-content-center"
          >
            <span class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              >Total pieces:{{ totalChargers }}
            </span>
            <span
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              style="display: none"
              >Total pallets:{{ totalPieces }}</span
            >
            <span
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              style="display: none"
              >Total :{{ resultsLengthOrderCharges }}</span
            >
          </p>
        </div>

        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-form-field>
            <mat-label>Search</mat-label>
            <mat-select formControlName="PlaceOrderCharges">
              <input
                matInput
                (keyup)="onKeyPlaceOrderCharges($event.target.value)"
                placeholder="search"
              />
              <mat-option *ngFor="let opt of PlaceOrderCharges2" [value]="opt">
                {{ opt.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field
          class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
        >
          <mat-label>Price</mat-label>
          <input
            matInput
            formControlName="Price"
            (change)="OnMultiplicarCharges()"
          />
        </mat-form-field>
        <mat-form-field
          class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
        >
          <mat-label>Quantity</mat-label>
          <input
            matInput
            formControlName="QuantityOC"
            (change)="OnMultiplicarCharges()"
          />
        </mat-form-field>
        <mat-form-field
          class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
        >
          <mat-label>Amount</mat-label>
          <input matInput formControlName="Amount" />
        </mat-form-field>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <button
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            mat-raised-button
            color="primary"
            (click)="AddOrderCharger()"
          >
            Add
          </button>
        </div>

        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-form-field>
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilterOrderCharges($event)"
              placeholder=""
              #input2
            />
          </mat-form-field>

          <div
            class="example-container mat-elevation-z8 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            *ngIf="searchTableOrderCharges"
          >
            <div
              class="example-loading-shade"
              *ngIf="
                isLoadingResultsOrderCharges || isRateLimitReachedOrderCharges
              "
            >
              <mat-spinner *ngIf="isLoadingResultsOrderCharges"></mat-spinner>
              <div
                class="example-rate-limit-reached"
                *ngIf="isRateLimitReachedOrderCharges"
              ></div>
            </div>

            <div class="example-table-container">
              <table
                mat-table
                [dataSource]="dataSourceOrderCharger"
                class="example-table"
                matSort
                matSortDirection="desc"
                #TableViewProcessordersChangesSort="matSort"
              >
                <!-- Created Column -->
                <ng-container matColumnDef="ID">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Options
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      mat-raised-button
                      color="danger"
                      (click)="OnDeleteOrderChanges(row)"
                    >
                      Delete
                    </button>
                  </td>
                </ng-container>
                <!-- Number Column -->
                <ng-container matColumnDef="tblOrderID">
                  <th mat-header-cell *matHeaderCellDef>Order</th>
                  <td mat-cell *matCellDef="let row">{{ row.tblOrderID }}</td>
                </ng-container>

                <!-- Title Column -->
                <ng-container matColumnDef="tblInvoiceListID">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Invoice list</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.tblInvoiceListID }}</div>
                  </td>
                </ng-container>

                <!-- State Column -->
                <ng-container matColumnDef="tblInvoiceListDescription">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Invoice list description</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">
                      {{ row.tblInvoiceListDescription }}
                    </div>
                  </td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="ChargeDescription">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Charge description</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ChargeDescription }}</div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="UnitPrice">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Unit Price</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.UnitPrice }}</div>
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="Quantity">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Quantity
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.Quantity }}</td>
                </ng-container>

                <ng-container matColumnDef="Total">
                  <th mat-header-cell *matHeaderCellDef>Total</th>
                  <td mat-cell *matCellDef="let row">{{ row.Total }}</td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsOrderCharges"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsOrderCharges"
                ></tr>
              </table>
            </div>

            <mat-paginator
              [length]="resultsLengthOrderCharges"
              #TableViewProcessordersChangesPaginator="matPaginator"
              [pageSizeOptions]="[5, 10, 25, 100]"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div mat-dialog-actions class="justify-content-center">
    <!--  <button mat-button (click)="onNoClick()">Salir</button>
    -->
    <!-- <button mat-button (click)="moveToSelectedTab('Order Charges')">Documento</button> -->
  </div>
</div>
